import { useRestForm } from '@shared/hooks/rest/form'
import { useEasyProvider } from '@shared/components/EasyProvider'

import * as yup from 'yup'
import axios from '@shared/utils/axios'

const schema = yup.object({
    name: yup.string()
        .required('اكتب هذه الخانة')
        .max(100, 'المكتوب طويل، الحد ١٠٠ حرف'),
    signature: yup.mixed(),
})

const buildFormData = (delegate) => {
    const formData = new FormData()

    Object.entries(delegate).forEach(([key, value]) => {
        if (key === 'signature' && value) {
            if(value instanceof File) {
                formData.append('signature', value)
            } else if (value == '') {
                formData.append('signature', '')
            }
        } else if (value !== null && value !== undefined) {
            formData.append(key, value)
        }
    })

    return formData
}

export const useForm = () => {
    const {
        instance,
        setFormVisibility
    } = useEasyProvider()
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const {
        form,
        mutate,
        isPending
    } = useRestForm({
        schema,
        defaultValues: instance,
        invalidate: [['pdc-delegates']],

        process: instance
            ? async delegate => await axios.patch(`settings/pdc-delegates/${delegate.id}/`, buildFormData(delegate), config)
            : async delegate => await axios.post(`settings/pdc-delegates/`, buildFormData(delegate), config),
        onFinish: sup => {
            sup()
            setFormVisibility(false)
        }
    })

    const handleClose = () => setFormVisibility(false)

    return {
        form,
        mutate,
        isPending,
        instance,
        handleClose
    }
}